import {
  createDefaultValueSimulator,
  RandomValueSimulator,
  VariableDataTypeConfig,
  VariableValueSimulator,
} from '@iotize/virtual-tap';
import { CounterValueSimulator } from '../models/counter-value-simultator';
import { GeometicBrownianMotionSimulator } from '../models/geometric-brownian-motion';

export function createSmartValueSimulator(
  name: string,
  type: VariableDataTypeConfig
): VariableValueSimulator {
  const lowerCase = name.toLowerCase();
  if (['temperature', 'temp'].find((v) => lowerCase.indexOf(v) >= 0)) {
    return new GeometicBrownianMotionSimulator({
      currentValue: 37,
      mean: 0,
      standardDeviation: 0.001,
      max: 40,
      min: 35,
    });
  } else if (
    ['ledconfig', 'ledstatus'].find((v) => lowerCase.indexOf(v) >= 0)
  ) {
    return new RandomValueSimulator({
      min: 0,
      max: 2,
    });
  } else if (['count'].find((v) => lowerCase.indexOf(v) >= 0)) {
    return new CounterValueSimulator({
      start: 0,
      step: 1,
      max: Math.pow(2, 16),
    });
  } else if (['voltage', 'volt'].find((v) => lowerCase.indexOf(v) >= 0)) {
    return new GeometicBrownianMotionSimulator({
      mean: 0,
      standardDeviation: 0.001,
      currentValue: 3.2,
      min: 3.1,
      max: 3.3,
    });
  } else {
    return createDefaultValueSimulator(type);
  }
}
